export default __webpack_public_path__ + "static/media/gloves4.5948ab3d.jpg";